import { BsInfoCircle } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

const ContributionComponent = ({
  lang,
  selectedContribution,
  setSelectedContribution,
  customAmount,
  setCustomAmount,
  cartTotal = 0,
  showInfoIcon = true,
  context = "charity" // 'charity' or 'tip'
}) => {
  const history = useHistory();

  const handleInfoClick = () => {
    if (context === "charity") {
      history.push("/social-support");
    }
  };

  return (
    <div style={{ width: "100%", marginBottom: 15 }}>
      {/* Header with Info Icon */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 8
        }}
      >
        <h3
          style={{
            textAlign: "left",
            alignSelf: "flex-start",
            marginBottom: 0,
            fontSize: 18,
            fontWeight: 600,
            color: "#333"
          }}
        >
          {t(`${context}_section.title`, lang)}
        </h3>
        {showInfoIcon && context === "charity" && (
          <BsInfoCircle
            style={{
              fontSize: 20,
              color: "#666",
              cursor: "pointer",
              marginLeft: 8
            }}
            onClick={handleInfoClick}
            title={t(`${context}_section.info_tooltip`, lang)}
          />
        )}
      </div>

      <p
        style={{
          fontSize: 13,
          color: "#666",
          margin: 0,
          lineHeight: "1.4",
          marginBottom: 15
        }}
      >
        {t(`${context}_section.subtitle`, lang)}
      </p>

      {/* Percentage Options */}
      <div
        style={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: 12,
          marginBottom: 20
        }}
      >
        {(() => {
          // Get emojis based on context
          const emojis =
            context === "charity"
              ? {
                  good: "🤍",
                  great: "💛",
                  excellent: "🧡",
                  amazing: "❤️‍🔥"
                }
              : {
                  good: "👍",
                  great: "⭐",
                  excellent: "🌟",
                  amazing: "💫"
                };

          return [
            {
              percentage: 15,
              label: t(`${context}_section.good`, lang),
              emoji: emojis.good
            },
            {
              percentage: 18,
              label: t(`${context}_section.great`, lang),
              emoji: emojis.great
            },
            {
              percentage: 20,
              label: t(`${context}_section.excellent`, lang),
              emoji: emojis.excellent
            },
            {
              percentage: 25,
              label: t(`${context}_section.amazing`, lang),
              emoji: emojis.amazing
            }
          ];
        })().map(({ percentage, label, emoji }) => {
          const tipAmount = (cartTotal * percentage) / 100;
          const isSelected =
            selectedContribution === `percentage_${percentage}`;

          return (
            <div
              key={percentage}
              style={{
                cursor: "pointer",
                padding: "14px 8px",
                textAlign: "center",
                backgroundColor: "#f8f9fa",
                color: "#333",
                borderRadius: 12,
                border: isSelected ? "2px solid #FF114D" : "2px solid #e9ecef",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                position: "relative"
              }}
              onClick={() => {
                setSelectedContribution(`percentage_${percentage}`);
                setCustomAmount(""); // Clear custom input when selecting percentage
              }}
            >
              <div
                style={{
                  fontSize: 16,
                  marginBottom: 4
                }}
              >
                {emoji}
              </div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  marginBottom: 2,
                  color: "#333"
                }}
              >
                {percentage}%
              </div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 400,
                  opacity: 0.7,
                  marginBottom: 2,
                  color: "#666"
                }}
              >
                {label}
              </div>
              <div
                style={{
                  fontSize: 11,
                  opacity: 0.8,
                  fontWeight: 400,
                  color: "#666"
                }}
              >
                ${tipAmount.toFixed(2)}
              </div>
              {isSelected && (
                <div
                  style={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                    border: "2px solid #FF114D"
                  }}
                >
                  <div
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: "#FF114D"
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}

        {/* No Contribution Option */}
        <div
          style={{
            cursor: "pointer",
            padding: "14px 8px",
            textAlign: "center",
            backgroundColor: "#f8f9fa",
            color: "#333",
            borderRadius: 12,
            border:
              selectedContribution === null
                ? "2px solid #FF114D"
                : "2px solid #e9ecef",
            transition: "all 0.2s ease",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            position: "relative"
          }}
          onClick={() => {
            setSelectedContribution(null);
            setCustomAmount(""); // Clear custom input when selecting no contribution
          }}
        >
          <div
            style={{
              fontSize: 16,
              marginBottom: 4
            }}
          >
            ❌
          </div>
          <div
            style={{
              fontSize: 13,
              fontWeight: 500,
              marginBottom: 2,
              color: "#333"
            }}
          >
            {t(`${context}_section.skip`, lang)}
          </div>
          <div
            style={{
              fontSize: 10,
              fontWeight: 400,
              opacity: 0.7,
              marginBottom: 2,
              color: "#666"
            }}
          >
            {t(`${context}_section.none`, lang)}
          </div>
          <div
            style={{
              fontSize: 11,
              opacity: 0.8,
              fontWeight: 400,
              color: "#666"
            }}
          >
            $0.00
          </div>
          {selectedContribution === null && (
            <div
              style={{
                position: "absolute",
                top: 6,
                right: 6,
                width: 20,
                height: 20,
                borderRadius: "50%",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                border: "2px solid #FF114D"
              }}
            >
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#FF114D"
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Custom Amount Input */}
      <div
        style={{
          width: "100%",
          marginBottom: 15
        }}
      >
        <div
          style={{
            fontSize: 12,
            color: "#666",
            marginBottom: 8,
            fontWeight: 500
          }}
        >
          {t(`${context}_section.custom_label`, lang)}
        </div>
        <div
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center"
          }}
        >
          <input
            value={customAmount}
            type="number"
            min="0"
            step="0.01"
            placeholder={t(`${context}_section.custom_placeholder`, lang)}
            onChange={(e) => {
              const value = e.target.value;
              if (
                value === "" ||
                (parseFloat(value) >= 0 && !isNaN(parseFloat(value)))
              ) {
                setCustomAmount(value);
                if (value !== "") {
                  setSelectedContribution("custom");
                }
              }
            }}
            style={{
              flex: 1,
              padding: "12px 16px",
              border: "2px solid #e9ecef",
              borderRadius: 8,
              fontSize: 14,
              outline: "none",
              transition: "border-color 0.2s ease",
              backgroundColor: "#fff"
            }}
          />
          <div
            style={{
              padding: "12px 20px",
              backgroundColor:
                customAmount && parseFloat(customAmount) > 0
                  ? "#FF114D"
                  : "#6c757d",
              color: "white",
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor:
                customAmount && parseFloat(customAmount) > 0
                  ? "pointer"
                  : "not-allowed",
              transition: "all 0.2s ease",
              opacity: customAmount && parseFloat(customAmount) > 0 ? 1 : 0.7
            }}
            onClick={() => {
              if (customAmount && parseFloat(customAmount) > 0) {
                setSelectedContribution("custom");
              }
            }}
          >
            {t(`${context}_section.custom_button`, lang)}
          </div>
        </div>
      </div>

      {/* Encouragement message */}
      {selectedContribution && selectedContribution !== null && (
        <div
          style={{
            width: "100%",
            padding: "12px 16px",
            backgroundColor: "#e8f5e8",
            borderRadius: 8,
            marginTop: 12,
            textAlign: "center"
          }}
        >
          <div
            style={{
              fontSize: 12,
              color: "#2d5a2d",
              fontWeight: 500
            }}
          >
            {t(`${context}_section.thank_you`, lang)}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContributionComponent;
